export default __webpack_public_path__ + "src/apps/Map/components/MapSelectorBar/images/hbi-ok@2x.png";